import { useState } from "react";

export enum RankTab {
  PUB = "PUB",
  ALL = "ALL",
}

export enum RankPeriodTab {
  SEASON = "SEASON",
  MONTH = "MONTH",
  WEEK = "WEEK",
}

export const useRank = () => {
  // 상단 탭
  const [mainTab, setMainTab] = useState(RankTab.PUB);
  // 하단 탭
  const [periodTab, setPeriodTab] = useState(RankPeriodTab.SEASON);

  const isMainTab = (tab: RankTab) => mainTab === tab;
  const isPeriodTab = (tab: RankPeriodTab) => periodTab === tab;

  return {
    mainTab,
    setMainTab,
    isMainTab,
    periodTab,
    setPeriodTab,
    isPeriodTab,
  };
};
